module.exports = __webpack_public_path__ + "static/img/resume_rousseau_kevin_en.44b6bad.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resume_rousseau_kevin_en.pdf
// module id = A4Sc
// module chunks = 1